import { render, staticRenderFns } from "./candidate-details-qualifications.vue?vue&type=template&id=6fb20eec&"
import script from "./candidate-details-qualifications.vue?vue&type=script&lang=js&"
export * from "./candidate-details-qualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports